// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1rRDu","head":"Table_head__3m1G7","col":"Table_col__L5aKZ"};